/* global Stripe */
import PropTypes from 'prop-types';

import React from 'react';

import StripeCheckoutModal from 'ondemand/components/StripeCheckoutModal';

const scriptUrl = 'https://js.stripe.com/v3/';
let scriptLoading = false;
let scriptLoaded = false;

// Suffix with "Component" to avoid name collision with stripe's API
class StripeCheckoutComponent extends React.Component {
  static displayName = 'StripeCheckout';

  static propTypes = {
    amount: PropTypes.number.isRequired,
    children: PropTypes.node,
    onToken: PropTypes.func.isRequired,
    publishableKey: PropTypes.string.isRequired,
  };

  state = {
    open: false,
    error: '',
  };

  componentDidMount() {
    if (scriptLoaded) {
      this._configureStripe();
      return;
    }

    if (scriptLoading) {
      const timer = setInterval(
        () => {
          if (!scriptLoaded) return;
          clearTimeout(timer);
          this._configureStripe();
        },
        500
      );
      return;
    }

    scriptLoading = true;

    const script = document.createElement('script');
    script.src = scriptUrl;
    script.async = 1;
    script.onload = () => {
      scriptLoaded = true;
      scriptLoading = false;
      this._configureStripe();
    };
    document.head.appendChild(script);
  }

  _configureStripe = () => {
    // Initialize the stripe SDK
    this._stripe = Stripe(this.props.publishableKey); // eslint-disable-line new-cap
    this.forceUpdate();
  };

  _handleClick = (e) => {
    if (!this.state.open) {
      this.setState({open: true});
    }
    e.preventDefault();
  };

  _handleClose = (e) => {
    this.setState({open: false});
    e.preventDefault();
  }

  render() {
    if (!scriptLoaded) return null;
    const {children, amount, onToken} = this.props;
    return (
      <span onClick={this._handleClick}>
        {children}
        {this.state.open &&
          <StripeCheckoutModal
            amount={amount}
            onClose={this._handleClose}
            onToken={onToken}
            stripe={this._stripe}
          />
        }
      </span>
    );
  }
}

export default StripeCheckoutComponent;



// WEBPACK FOOTER //
// ./src/ondemand/components/StripeCheckout.js